import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

const N = 5;

function scramble() {
  let g = Array(N * N).fill(false);
  const toggle = (grid, i) => {
    const r = Math.floor(i / N), c = i % N;
    [[0, 0], [1, 0], [-1, 0], [0, 1], [0, -1]].forEach(([dr, dc]) => {
      const nr = r + dr, nc = c + dc;
      if (nr >= 0 && nr < N && nc >= 0 && nc < N) grid[nr * N + nc] = !grid[nr * N + nc];
    });
  };
  for (let k = 0; k < 8; k++) toggle(g, Math.floor(Math.random() * N * N));
  return g;
}

export function LightsOut({ onScore }) {
  const [grid, setGrid] = useState(scramble);
  const [moves, setMoves] = useState(0);
  const [running, setRunning] = useState(false);
  const [won, setWon] = useState(false);
  const reported = useRef(false);

  const start = () => { setGrid(scramble()); setMoves(0); setRunning(true); setWon(false); reported.current = false; };

  const press = (i) => {
    if (!running) return;
    const g = [...grid];
    const r = Math.floor(i / N), c = i % N;
    [[0, 0], [1, 0], [-1, 0], [0, 1], [0, -1]].forEach(([dr, dc]) => {
      const nr = r + dr, nc = c + dc;
      if (nr >= 0 && nr < N && nc >= 0 && nc < N) g[nr * N + nc] = !g[nr * N + nc];
    });
    setGrid(g); setMoves((m) => m + 1);
    if (g.every((v) => !v)) { setWon(true); setRunning(false); }
  };

  useEffect(() => { if (won && !reported.current) { reported.current = true; onScore?.(Math.max(100, 1000 - moves * 30)); } }, [won, moves, onScore]);

  return (
    <div className="flex flex-col items-center" data-testid="lights-out">
      <p className="font-mono text-neon-cyan text-lg mb-3" data-testid="lights-moves">MOVES: {moves}</p>
      <div className="relative grid gap-2 p-2 bg-zinc-900 border-2 border-zinc-700 rounded-xl" style={{ gridTemplateColumns: `repeat(${N}, 1fr)`, width: "min(88vw, 320px)" }}>
        {grid.map((on, i) => (
          <button key={i} onClick={() => press(i)} data-testid={`lights-cell-${i}`}
            className="aspect-square rounded-lg transition-all"
            style={{ background: on ? "#EFFF04" : "#27272a", boxShadow: on ? "0 0 14px #EFFF04" : "none" }} />
        ))}
        {!running && (
          <div className="absolute inset-0 bg-black/85 rounded-xl flex flex-col items-center justify-center gap-3">
            {won && <p className="font-display font-black text-2xl text-neon-lime uppercase" data-testid="lights-won">Lights Out! {moves} moves</p>}
            <Button onClick={start} data-testid="lights-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase">
              <Play className="w-4 h-4 mr-1 fill-black" /> {won ? "Play Again" : "Start"}
            </Button>
          </div>
        )}
      </div>
      <p className="text-zinc-500 text-xs font-mono mt-3">Turn off ALL the lights. Each tap flips a plus-shape.</p>
    </div>
  );
}
